import React from 'react';
import PropTypes from 'prop-types';
import { IssuePriority, getIssuePriority } from 'shared/constants/issues';

import {
  EmergencyRegular,
  Emergency1Hour,
  Emergency3Hours,
  Emergency24Hours,
  NotEmergency,
} from './styles';

const propTypes = {
  priority: PropTypes.string,
};

const DataTableEmergency = ({ priority }) => {
  switch (priority.toString()) {
    case IssuePriority.HIGHEST: //5
      return <Emergency1Hour>{getIssuePriority(priority)}</Emergency1Hour>;
    case IssuePriority.HIGH: //4
      return <Emergency3Hours>{getIssuePriority(priority)}</Emergency3Hours>;
    case IssuePriority.MEDIUM: //3
      return <Emergency24Hours>{getIssuePriority(priority)}</Emergency24Hours>;
    case IssuePriority.LOW: //2
      return <EmergencyRegular>{getIssuePriority(priority)}</EmergencyRegular>;
    case IssuePriority.LOWEST: //1
      return <NotEmergency>{getIssuePriority(priority)}</NotEmergency>;
    default:
      break;
  }
  return <div></div>;
};
DataTableEmergency.propTypes = propTypes;

export default DataTableEmergency;
